import React from 'react'

const LoaderModal = () => {
    return (
        <div className="fixed inset-0 bg-black bg-opacity-30 flex justify-center items-center z-50">
            <div className="flex justify-center items-center">
                <div className="flex space-x-2">
                    <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce delay-0"></div>
                    <div className="w-3 h-3 bg-blue-500 rounded-full animate-bounce delay-200"></div>
                    <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce delay-400"></div>
                </div>
            </div>
        </div>
    )
}

export default LoaderModal